<script>
  import { _ } from 'svelte-i18n'
  import { modals, subscription_email_mismatch } from '../../stores'
  import { saveUserPassword, 
    runUserDataRoutine, 
    getUserSubscriptionRelatedData 
  } from '../../services/user'
  import Fieldset from '../../elements/Fieldset.svelte'
  import Label from '../../elements/Label.svelte'
  import Input from '../../elements/Input.svelte'
  import Button from '../../elements/Button.svelte'
  import FormError from '../../elements/FormError.svelte'
  import Modal from '../../elements/Modal.svelte'

  let modal_id = 'setPassword'
  let button_busy = false
  let form_element
  let passwords_match_error = false
  let reset_error = false
  let show_success = false

  async function handleSubmit(event) {
    passwords_match_error = reset_error = false
    if (event.target.password1.value !== event.target.password2.value) {
      passwords_match_error = true
      return
    }
    button_busy = true
    
    let form_data = new FormData()
    form_data.append('password', event.target.password1.value)
    
    // get new user data
    let user = await saveUserPassword(form_data)
    
    // get/set user_subscription and set user_valid
    await runUserDataRoutine(user.data)

    // Get user subscription related data
    await getUserSubscriptionRelatedData()
  
    show_success = true
  }

</script>

<Modal id={modal_id} persistent={true}>
  <span slot="header">
    { show_success ? $_('modals.setPassword.titleSuccess') : $_('modals.setPassword.title')}
  </span>
  <span slot="content">
    <FormError bind:visible={passwords_match_error}>{$_('modals.reset.passwordsMatchError')}</FormError>
    <FormError bind:visible={reset_error}>{@html $_('modals.reset.resetError')}</FormError>
    
    {#if !show_success}
      <p>{$_('modals.setPassword.content')}</p>
      <form bind:this={form_element} on:submit|preventDefault="{handleSubmit}">
        <Fieldset>
          <Label name="password1">{$_('forms.newPassword')}</Label>
          <Input type="password" name="password1" required={true} autocomplete="new-password"/>
        </Fieldset>
        <Fieldset>
          <Label name="password2">{$_('forms.confirmNewPassword')}</Label>
          <Input type="password" name="password2" required={true} autocomplete="new-password"/>
        </Fieldset>
        <Button kind="accent" type="submit" busy={button_busy}>{$_('buttons.savePassword')}</Button>
      </form>
    {:else}
      <p class:mb-3={!$subscription_email_mismatch}>{$_('modals.setPassword.contentSuccess')}</p>
      {#if $subscription_email_mismatch}
        <div class="subscription-email-mismatch">
          {@html $_('modals.setPassword.subscriptionEmailMismatch', { values: {
            currentEmail: $subscription_email_mismatch.current_email,
            subscriptionEmail: $subscription_email_mismatch.subscription_email
          }})}
        </div>
      {/if}
      <Button kind="accent" on:click={() => modals.close('setPassword')}>{$_('buttons.ok')}</Button>
    {/if}
  </span>
</Modal>

<style>
  .subscription-email-mismatch {
    margin-bottom: 3rem;
  }
  .subscription-email-mismatch :global(p) {
    margin-top: 1.5rem;
  }
  .subscription-email-mismatch :global(p.accent) {
    color: var(--c-accent-orange);
    font-family: var(--PensumSans-Bold);
  }
  .mb-3 {
    margin-bottom: 3rem;
  }
</style>